import get from 'lodash/get';

export default function createService(props) {
  return {
    getUser: () => {
      const jwt = get(props, 'viewer.jwtToken', '');
      const data = get(props, 'viewer.idToken', {});
      return {
        jwt,
        uuid: get(data, 'sub', ''),
        email: get(data, 'email', ''),
        firstName: get(data, 'given_name', ''),
        lastName: get(data, 'family_name', ''),
        institutionScid: get(data, 'custom:institution', ''),
        institutionType: 'HE',
        role: get(data, 'custom:role', ''),
      };
    },
  };
}
